import React from 'react';
import { Linkedin, Github, Instagram, Heart } from 'lucide-react';
import { personalInfo, socialLinks, certifications } from '../data/mock';

const iconMap = { Linkedin, Github, Instagram };

const Footer = () => {
  return (
    <footer className="py-12 bg-gradient-to-r from-purple-600 via-blue-600 to-violet-600 relative overflow-hidden">
      {/* Floating Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-5 left-10 text-3xl opacity-20 animate-float">🚀</div>
        <div className="absolute top-10 right-20 text-3xl opacity-20 animate-float" style={{ animationDelay: '1s' }}>⭐</div>
        <div className="absolute bottom-5 left-1/4 text-3xl opacity-20 animate-float" style={{ animationDelay: '0.5s' }}>🛡️</div>
      </div>

      <div className="max-w-6xl mx-auto px-6 relative z-10">
        {/* Certifications as Badges */}
        <div className="flex flex-wrap justify-center gap-3 mb-8">
          {certifications.map((cert, i) => (
            <div 
              key={i}
              className="px-3 py-1.5 bg-white/15 backdrop-blur-sm rounded-full text-white font-semibold text-sm flex items-center gap-2 hover:bg-white/25 transition-colors"
            >
              <span>{cert.icon}</span>
              <span>{cert.name}</span>
            </div>
          ))}
        </div>

        {/* Logo & Name */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-3">
            <div className="w-14 h-14 rounded-2xl bg-white/20 backdrop-blur-sm flex items-center justify-center text-3xl">
              🦸
            </div>
            <span className="text-white font-black text-2xl">
              Captain DevSecOps
            </span>
          </div>
        </div>

        {/* Social Links */}
        <div className="flex justify-center gap-4 mb-8">
          {socialLinks.map((link) => {
            const Icon = iconMap[link.icon];
            return (
              <a
                key={link.name}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 rounded-xl bg-white/20 backdrop-blur-sm flex items-center justify-center text-white hover:bg-white/40 hover:scale-110 transition-all"
              >
                {Icon && <Icon className="w-5 h-5" />}
              </a>
            );
          })}
        </div>

        {/* Copyright */}
        <div className="text-center text-white/80">
          <p className="flex items-center justify-center gap-2 font-medium">
            Made with <Heart className="w-5 h-5 text-red-300 fill-red-300 animate-pulse" /> by {personalInfo.name}
          </p>
          <p className="text-white/60 text-sm mt-2">
            © {new Date().getFullYear()} • Building secure cloud infrastructure
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
